// extracted by mini-css-extract-plugin
module.exports = {"CookieBanner":"_1bhMQS","CookieBannerBody":"_1zXShB","CookieBannerTitle":"vXVmvM","CookieBannerMessage":"_3AV_Og","CookieBannerCloseButton":"_3aPDms"};